const html = require("./html/caseArrivalAndTrackingRowView.html");
import {setElementsFromScope, insertValAndManageFocus, show, hide, enableInput, disableInput, setRequired, setUniqNamesAndIds, setDisabled} from "../../../utilities/selectorHelpers";
import _ from "underscore";
import $ from "jquery";


const elementsMap = {
  trackingNumberInput: ".case-tracking-number-input",
  expectedArrivalDateInput: ".case-expected-arrival-date-input",
  palletCaseIdx: ".pallet-case-idx"
};

export default function CaseArrivalAndTrackingRowView(asnDetail, 
  {
    readOnly,
    onAsnDetailGroupFieldChange,
    rowIdx
  }){
  const asnDetailId = asnDetail.id;


  const self = this;
  self._element = $();
  const els = {};

  self.init = function(){
    render();
  };

  function bindElements(){
    els.trackingNumberInput.on("blur", onAsnDetailGroupFieldChangeFunc("asd_tracking_number"));
    els.expectedArrivalDateInput.on("input change", onAsnDetailGroupFieldChangeFunc("asd_expected_arrival_date"));
  }


  function onAsnDetailGroupFieldChangeFunc(asnKeyName){
    return (e)=>{
      const val = $(e.target).val();
      onAsnDetailGroupFieldChange(rowIdx, asnKeyName, val);
    }
  }



  function setWidgets(){
    instantiateExpArrivalDatePicker();
  }

  function instantiateExpArrivalDatePicker(){
    const date = new Date();
    const enddate = new Date();
    enddate.setDate(enddate.getDate() + 30);
    els.expectedArrivalDateInput.datepicker({ 
      startDate: date,
      endDate: enddate,
      todayBtn: "linked",
      keyboardNavigation: false,
      forceParse: false,
      calendarWeeks: true,
      autoclose: true
    });
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  self.getElement = function(){
    return self._element;
  }


  function update(){
    // handle rendering children
    updateSelf();
  }

  function updateSelf(){
    // handle updating values;
    updateValues();
    updatePalletCaseIdx();
  }

  function updateValues(){
    insertValAndManageFocus(els.trackingNumberInput, getAsnDetail().asd_tracking_number);
    insertValAndManageFocus(els.expectedArrivalDateInput, getAsnDetail().asd_expected_arrival_date);
  }

  function bindStores(){
    AsnDetailStore.bindListener(`asn_details:change:${asnDetailId}`, updateSelf);
  }

  self.unbindListeners = function(){
    AsnDetailStore.unbindListener(`asn_details:change:${asnDetailId}`, updateSelf);
  };


  function updatePalletCaseIdx(){
    els.palletCaseIdx.text(rowIdx + 1);
  }




  function defaultToOne(numb){
    return (numb || 1);
  }

  function render(){
    self._element = $(html);
    setElements();
    setUniqNamesAndIds([els.trackingNumberInput, els.expectedArrivalDateInput]);
    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
    setRequired([els.expectedArrivalDateInput]);
    handleReadOnly();
    setWidgets();
    bindElements();
    bindStores();
    update();
  }

  function handleReadOnly(){
    if(readOnly){
      setDisabled([els.trackingNumberInput, els.expectedArrivalDateInput]);
    }
  }

  function getAsnDetail(){
    return AsnDetailStore.getAsnDetail(asnDetailId);
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/CaseArrivalAndTrackingRowView.js